// extracted by mini-css-extract-plugin
module.exports = {"sim-logo-container":"simLogo_sim-logo-container__16ryq","sim-logo":"simLogo_sim-logo__2bdVz","sim-name":"simLogo_sim-name__2JwEe","sim-image":"simLogo_sim-image__3XZbU"};